import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Chip from '@material-ui/core/Chip';
import InputBase from '@material-ui/core/InputBase';

import CloseIcon from '@material-ui/icons/Close';

import { useStyles } from './styles';

const MultiSelect = ({
  input,
  isHiddenErrorMsg,
  list,
  field,
  className,
  label,
  meta: { touched, error, submitFailed }
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classNames(classes.wrapper, className)}>
      {label && (
        <InputLabel
          className={classes.label}
          htmlFor={`${label}-currency-input`}
          classes={{
            disabled: classes.disabledLabel
          }}
        >
          {label}
        </InputLabel>
      )}
      <Select
        multiple
        value={input.value}
        onChange={input.onChange}
        classes={{
          root: classes.selectRoot
        }}
        renderValue={selected => (
          <div className={classes.chips}>
            {selected.map(value => (
              <Chip
                key={value}
                onMouseDown={e => e.stopPropagation()}
                label={value}
                className={classes.chip}
                onDelete={() =>
                  input.onChange(input.value.filter(item => item !== value))
                }
                deleteIcon={<CloseIcon className={classes.deleteChipIcon} />}
              />
            ))}
          </div>
        )}
        MenuProps={{
          classes: {
            list: classes.menuList
          }
        }}
        input={
          <InputBase
            classes={{
              root: classNames(classes.inputRoot, {
                [classes.error]: (touched || submitFailed) && error
              })
            }}
          />
        }
      >
        {list.map((item, index) => (
          <MenuItem
            key={index}
            value={field ? item['id'] : item}
            classes={{ root: classes.menuItemRoot }}
          >
            {field ? item[field] : item}
          </MenuItem>
        ))}
      </Select>
      {!isHiddenErrorMsg && (touched || submitFailed) && error && (
        <FormHelperText error>{t(error)}</FormHelperText>
      )}
    </div>
  );
};

export default MultiSelect;
